import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { bootstrapShop, syncBilling } from "../lib/safegeo-api";
import { SafePage } from "../components/SafePage";
import { PageIntro } from "../components/PageIntro";
import { AppButton } from "../components/AppButton";
import { WarningBanner } from "../components/PageBanner";

/** Billing return: /app/welcome?plan_handle=… → sync → Home */
export function WelcomePage() {
  const [params] = useSearchParams();
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await bootstrapShop({});
        const planHandle = params.get("plan_handle");
        const planKey = params.get("plan_key");
        if (planHandle || planKey) {
          await syncBilling({
            plan_key: planKey || "safegeo-starter",
            billing_interval:
              (params.get("interval") as "month" | "year") || "year",
            plan_handle: planHandle,
          });
        }
        if (!cancelled) setDone(true);
      } catch (e) {
        if (!cancelled) {
          setError(e instanceof Error ? e.message : String(e));
          setDone(true);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [params]);

  if (!done) {
    return (
      <SafePage screen="welcome" heading="Updating your plan">
        <PageIntro>
          Syncing with Shopify billing - you’ll land on Home in a moment.
        </PageIntro>
      </SafePage>
    );
  }
  if (error) {
    return (
      <SafePage screen="welcome" heading="Plan update">
        <WarningBanner heading="Couldn’t sync automatically">
          {error} Continuing to Home - check Plan if anything looks off.
        </WarningBanner>
        <s-box paddingBlockStart="base">
          <AppButton variant="primary" to="/app">
            Go to Home
          </AppButton>
        </s-box>
        <Navigate to="/app" replace />
      </SafePage>
    );
  }
  return <Navigate to="/app" replace />;
}
